// src/components/modals/CreateAccessKeyModal.jsx

import React from "react";
import "./modals.css";

export default function CreateAccessKeyModal({ show, onClose, onSubmit }) {
  if (!show) return null;

  const handleClick = () => {
    onSubmit();    // não precisa passar dados, o MC gera tudo
  };

  return (
    <div className="access-key-modal-overlay" onClick={onClose}>
      <div className="access-key-modal-content" onClick={e=>e.stopPropagation()}>
        <button className="modal-close" onClick={onClose}>×</button>
        <h3>Criar nova Access Key</h3>
        <p>Ao clicar em “Criar”, o sistema irá gerar uma nova Access Key e Secret Key.</p>
        <div className="d-flex justify-content-end mt-3">
          <button className="btn btn-secondary me-2" onClick={onClose}>
            Cancelar
          </button>
          <button className="btn btn-primary" onClick={handleClick}>
            Criar
          </button>
        </div>
      </div>
    </div>
  );
}
